import React from 'react';
import { Form } from 'react-final-form';
import { Grid, Button } from '@material-ui/core';
import { FieldTextInput } from '../FieldTextInput';
import strings from '../../resources/strings';
import { ResetPasswordFormProps } from './types';
import './ResetPasswordForm.scss';

const ResetPasswordForm: React.FC<ResetPasswordFormProps> = (props) => {
    const onSubmitHandler = (data: { email: string }) => {
        props.onSubmit(data.email);
    };

    return (
        <Form
            onSubmit={onSubmitHandler}
            render={({ handleSubmit }) => {
                return (
                    <form className="form" onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <FieldTextInput
                                    variant="outlined"
                                    required
                                    type="email"
                                    id="email"
                                    label={strings.resetPasswordPage.labels.email}
                                    name="email"
                                    autoComplete="email"
                                    autoFocus
                                />
                            </Grid>
                        </Grid>
                        <Button type="submit" fullWidth variant="contained" color="primary" className="submit">
                            {strings.resetPasswordPage.buttons.continue}
                        </Button>
                    </form>
                );
            }}
        />
    );
};

export default ResetPasswordForm;
